import React, { useState } from 'react';
import {
  Container,
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  Alert
} from '@mui/material';
import axios from 'axios';

import { colors } from '../styles/colors';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Chutt... Logo SVG Component - 5 descending bars (noise reduction)
const ChuttLogo = ({ size = 80, color = '#1A1F1D' }) => (
  <svg width={size} height={size * 0.6} viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* Tallest bar in brand green, rest in charcoal with descending opacity */}
    <rect x="5" y="5" width="14" height="50" rx="3" fill={colors.primaryLight}/>
    <rect x="24" y="12" width="14" height="43" rx="3" fill={color} opacity="0.75"/>
    <rect x="43" y="22" width="14" height="33" rx="3" fill={color} opacity="0.55"/>
    <rect x="62" y="32" width="14" height="23" rx="3" fill={color} opacity="0.4"/>
    <rect x="81" y="42" width="14" height="13" rx="3" fill={color} opacity="0.25"/>
  </svg>
);

function Login({ setAuth }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('username', email);
      formData.append('password', password);

      const response = await axios.post(`${API_URL}/api/auth/login`, formData);

      // Store token
      localStorage.setItem('token', response.data.access_token);

      // Set authenticated
      setAuth(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: colors.gray50,
        position: 'relative',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: 5,
            borderRadius: 3,
            bgcolor: 'white',
            border: `1px solid ${colors.gray200}`,
          }}
        >
          {/* Logo and Brand */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <ChuttLogo size={100} color={colors.charcoal} />
            <Typography
              sx={{
                mt: 2,
                fontFamily: "'Dancing Script', cursive",
                fontWeight: 700,
                fontSize: '2.5rem',
                color: colors.charcoal,
              }}
            >
              Chutt...
            </Typography>
            <Typography
              variant="caption"
              sx={{
                display: 'block',
                mt: 0.5,
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: colors.gray600,
                fontWeight: 500,
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '0.7rem',
              }}
            >
              Reputation Intelligence
            </Typography>
          </Box>

          {/* Divider */}
          <Box
            sx={{
              width: '40px',
              height: '2px',
              bgcolor: colors.primary,
              mx: 'auto',
              mb: 4,
            }}
          />

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleLogin}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Mot de passe"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                mt: 3,
                mb: 2,
                py: 1.5,
                bgcolor: colors.primary,
                fontWeight: 600,
                fontSize: '0.95rem',
                '&:hover': {
                  bgcolor: colors.primaryDark,
                },
              }}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>

          <Typography
            variant="caption"
            display="block"
            align="center"
            sx={{ mt: 3, color: colors.gray400 }}
          >
            v2.0
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default Login;
